var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('fragment',[_c('li',[_c('router-link',{attrs:{"to":{name: _vm.route}}},[_vm._v(" "+_vm._s(_vm.label)+" ")])],1),(_vm.withSeparator === true)?_c('span',{staticClass:"hidden md:inline self-center"},[_vm._v("|")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }